
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Image, Paperclip, Send } from "lucide-react";
import { Profile } from "@/hooks/useProfile";

interface PostActionsProps {
  prompt: string;
  maxLength: number;
  mediaFiles: File[];
  attachmentFiles: File[];
  isPrivate: boolean;
  setIsPrivate: (value: boolean) => void;
  profile: Profile | null;
  onMediaClick: () => void;
  onAttachmentClick: () => void;
  onSubmit: () => void;
}

export const PostActions = ({
  prompt,
  maxLength,
  mediaFiles,
  attachmentFiles,
  isPrivate,
  setIsPrivate,
  profile,
  onMediaClick,
  onAttachmentClick,
  onSubmit,
}: PostActionsProps) => {
  return (
    <div className="flex items-center justify-between gap-3">
      <div className="flex items-center gap-4">
        <span className={`text-xs ${prompt.length === maxLength ? 'text-red-400' : 'text-gray-400'}`}>
          {prompt.length}/{maxLength}
        </span>
        <Button
          variant="ghost"
          size="sm"
          onClick={onMediaClick}
          className="text-gray-400 hover:text-white p-0"
        >
          <Image className="w-4 h-4" />
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={onAttachmentClick}
          className="text-gray-400 hover:text-white p-0"
        >
          <Paperclip className="w-4 h-4" />
        </Button>
        {profile?.is_pro && (
          <div className="flex items-center gap-2">
            <Switch
              id="private-mode"
              checked={isPrivate}
              onCheckedChange={setIsPrivate}
              className="data-[state=checked]:bg-flux-cyan"
            />
            <Label htmlFor="private-mode" className="text-sm text-gray-400">
              Private
            </Label>
          </div>
        )}
      </div>
      <Button 
        onClick={onSubmit}
        size="sm"
        className="bg-white hover:bg-white/90 text-black"
        disabled={prompt.length === 0 && mediaFiles.length === 0 && attachmentFiles.length === 0}
      >
        <Send className="w-4 h-4" />
      </Button>
    </div>
  );
};
